export const ETICHETE_SURSA: Record<string, string> = {
  onrc: "ONRC",
  lista: "Liste oficiale",
  liste: "Liste oficiale",
  site: "Site firmă",
  web: "Internet",
  termene: "Termene.ro",
  import: "Import CSV",
  manual: "Manual",
  presupus: "Presupus (tipar)",
  linkedin: "LinkedIn",
  mf_bilant: "Ministerul Finanțelor",
  nis2pass: "Platforma NIS2PASS",
  anaf: "ANAF",
  anaf_live: "ANAF",
  anaf_cache: "ANAF (memorat)",
  onrc_local: "ONRC",
  mf: "Ministerul Finanțelor",
  mf_ir: "Ministerul Finanțelor",
  mf_ic: "Ministerul Finanțelor",
  productie_2024: "Ministerul Finanțelor",
  infocui: "InfoCUI",
  fara_bilant: "fără bilanț",
};

export const SURSE_CONTACT: readonly string[] = [
  "onrc",
  "lista",
  "site",
  "web",
  "termene",
  "import",
  "manual",
  "presupus",
  "linkedin",
  "nis2pass",
];

export function etichetaSursa(sursa: string | null | undefined): string {
  if (!sursa) return "";
  return sursa
    .split(",")
    .map((s) => {
      const cheie = s.trim().split(":")[0];
      return ETICHETE_SURSA[cheie] ?? cheie;
    })
    .filter((s, i, arr) => s && arr.indexOf(s) === i)
    .join(", ");
}
